export default __webpack_public_path__ + "static/SonarSwift-57ed53abf3e6248c69e68600bf83ded5.png";